angular.module('app').controller('CampanhasIndexController', function($scope, $http, $timeout) {
    $scope.filtro = {};
    
});
